import FooterMenu from './FooterMenu';

export default FooterMenu;
